import { FC, ReactNode, HTMLAttributes } from 'react';
import Link from '@base/lib/ThemeLink';
import cn from 'classnames';
import styles from '@app/common/PageHeader/HeaderBar/index.module.less';

export type HeaderBarTriggerProps = HTMLAttributes<HTMLElement> & {
    content: ReactNode;
    target?: string;
    href?: string;
    className?: string;
    arrow?: boolean;
    type?: 'text' | 'icon';
}

const HeaderBarTrigger: FC<HeaderBarTriggerProps> = props => {
    const {
        content,
        className,
        href,
        target,
        arrow = false,
        type: propsType,
        ...rest
    } = props;

    const type = propsType || (typeof content === 'string' ? 'text' : 'icon');
    const triggerClass = cn(className, styles.widget, styles['widget-trigger'], 'widget-trigger', styles[`widget-trigger-${type}`]);

    return href ? (
        <Link href={href} passHref>
            <a className={triggerClass} target={target} {...rest}>
                {content}
                {arrow && <em className={styles.arrow}/>}
            </a>
        </Link>
    ) : (
        <div className={triggerClass} {...rest}>
            {content}
            {arrow && <em className={styles.arrow}/>}
        </div>
    );
}

export default HeaderBarTrigger;
